import Box from '@mui/material/Box'
import { keyframes } from '@emotion/react';
import { styled, SxProps } from '@mui/system';


export interface IDotCircleLoaderProps {
    sx?:SxProps
}

const animate = keyframes`
0%,
  100% {
    box-shadow: 0em -2.6em 0em 0em #1fae5c, 1.8em -1.8em 0 0em rgba(31,174,92, 0.2), 2.5em 0em 0 0em rgba(31,174,92, 0.2), 1.75em 1.75em 0 0em rgba(31,174,92, 0.2), 0em 2.5em 0 0em rgba(31,174,92, 0.2), -1.8em 1.8em 0 0em rgba(31,174,92, 0.2), -2.6em 0em 0 0em rgba(31,174,92, 0.5), -1.8em -1.8em 0 0em rgba(31,174,92, 0.7);
  }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(31,174,92, 0.7), 1.8em -1.8em 0 0em #1fae5c, 2.5em 0em 0 0em rgba(31,174,92, 0.2), 1.75em 1.75em 0 0em rgba(31,174,92, 0.2), 0em 2.5em 0 0em rgba(31,174,92, 0.2), -1.8em 1.8em 0 0em rgba(31,174,92, 0.2), -2.6em 0em 0 0em rgba(31,174,92, 0.2), -1.8em -1.8em 0 0em rgba(31,174,92, 0.5);
  }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(31,174,92, 0.5), 1.8em -1.8em 0 0em rgba(31,174,92, 0.7), 2.5em 0em 0 0em #1fae5c, 1.75em 1.75em 0 0em rgba(31,174,92, 0.2), 0em 2.5em 0 0em rgba(31,174,92, 0.2), -1.8em 1.8em 0 0em rgba(31,174,92, 0.2), -2.6em 0em 0 0em rgba(31,174,92, 0.2), -1.8em -1.8em 0 0em rgba(31,174,92, 0.2);
  }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(31,174,92, 0.2), 1.8em -1.8em 0 0em rgba(31,174,92, 0.5), 2.5em 0em 0 0em rgba(31,174,92, 0.7), 1.75em 1.75em 0 0em #1fae5c, 0em 2.5em 0 0em rgba(31,174,92, 0.2), -1.8em 1.8em 0 0em rgba(31,174,92, 0.2), -2.6em 0em 0 0em rgba(31,174,92, 0.2), -1.8em -1.8em 0 0em rgba(31,174,92, 0.2);
  }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(31,174,92, 0.2), 1.8em -1.8em 0 0em rgba(31,174,92, 0.2), 2.5em 0em 0 0em rgba(31,174,92, 0.5), 1.75em 1.75em 0 0em rgba(31,174,92, 0.7), 0em 2.5em 0 0em #1fae5c, -1.8em 1.8em 0 0em rgba(31,174,92, 0.2), -2.6em 0em 0 0em rgba(31,174,92, 0.2), -1.8em -1.8em 0 0em rgba(31,174,92, 0.2);
  }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(31,174,92, 0.2), 1.8em -1.8em 0 0em rgba(31,174,92, 0.2), 2.5em 0em 0 0em rgba(31,174,92, 0.2), 1.75em 1.75em 0 0em rgba(31,174,92, 0.5), 0em 2.5em 0 0em rgba(31,174,92, 0.7), -1.8em 1.8em 0 0em #1fae5c, -2.6em 0em 0 0em rgba(31,174,92, 0.2), -1.8em -1.8em 0 0em rgba(31,174,92, 0.2);
  }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(31,174,92, 0.2), 1.8em -1.8em 0 0em rgba(31,174,92, 0.2), 2.5em 0em 0 0em rgba(31,174,92, 0.2), 1.75em 1.75em 0 0em rgba(31,174,92, 0.2), 0em 2.5em 0 0em rgba(31,174,92, 0.5), -1.8em 1.8em 0 0em rgba(31,174,92, 0.7), -2.6em 0em 0 0em #1fae5c, -1.8em -1.8em 0 0em rgba(31,174,92, 0.2);
  }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(31,174,92, 0.2), 1.8em -1.8em 0 0em rgba(31,174,92, 0.2), 2.5em 0em 0 0em rgba(31,174,92, 0.2), 1.75em 1.75em 0 0em rgba(31,174,92, 0.2), 0em 2.5em 0 0em rgba(31,174,92, 0.2), -1.8em 1.8em 0 0em rgba(31,174,92, 0.5), -2.6em 0em 0 0em rgba(31,174,92, 0.7), -1.8em -1.8em 0 0em #1fae5c;
  }
}
@keyframes load5 {
  0%,
  100% {
    box-shadow: 0em -2.6em 0em 0em #1fae5c, 1.8em -1.8em 0 0em rgba(31,174,92, 0.2), 2.5em 0em 0 0em rgba(31,174,92, 0.2), 1.75em 1.75em 0 0em rgba(31,174,92, 0.2), 0em 2.5em 0 0em rgba(31,174,92, 0.2), -1.8em 1.8em 0 0em rgba(31,174,92, 0.2), -2.6em 0em 0 0em rgba(31,174,92, 0.5), -1.8em -1.8em 0 0em rgba(31,174,92, 0.7);
  }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(31,174,92, 0.7), 1.8em -1.8em 0 0em #1fae5c, 2.5em 0em 0 0em rgba(31,174,92, 0.2), 1.75em 1.75em 0 0em rgba(31,174,92, 0.2), 0em 2.5em 0 0em rgba(31,174,92, 0.2), -1.8em 1.8em 0 0em rgba(31,174,92, 0.2), -2.6em 0em 0 0em rgba(31,174,92, 0.2), -1.8em -1.8em 0 0em rgba(31,174,92, 0.5);
  }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(31,174,92, 0.5), 1.8em -1.8em 0 0em rgba(31,174,92, 0.7), 2.5em 0em 0 0em #1fae5c, 1.75em 1.75em 0 0em rgba(31,174,92, 0.2), 0em 2.5em 0 0em rgba(31,174,92, 0.2), -1.8em 1.8em 0 0em rgba(31,174,92, 0.2), -2.6em 0em 0 0em rgba(31,174,92, 0.2), -1.8em -1.8em 0 0em rgba(31,174,92, 0.2);
  }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(31,174,92, 0.2), 1.8em -1.8em 0 0em rgba(31,174,92, 0.5), 2.5em 0em 0 0em rgba(31,174,92, 0.7), 1.75em 1.75em 0 0em #1fae5c, 0em 2.5em 0 0em rgba(31,174,92, 0.2), -1.8em 1.8em 0 0em rgba(31,174,92, 0.2), -2.6em 0em 0 0em rgba(31,174,92, 0.2), -1.8em -1.8em 0 0em rgba(31,174,92, 0.2);
  }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(31,174,92, 0.2), 1.8em -1.8em 0 0em rgba(31,174,92, 0.2), 2.5em 0em 0 0em rgba(31,174,92, 0.5), 1.75em 1.75em 0 0em rgba(31,174,92, 0.7), 0em 2.5em 0 0em #1fae5c, -1.8em 1.8em 0 0em rgba(31,174,92, 0.2), -2.6em 0em 0 0em rgba(31,174,92, 0.2), -1.8em -1.8em 0 0em rgba(31,174,92, 0.2);
  }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(31,174,92, 0.2), 1.8em -1.8em 0 0em rgba(31,174,92, 0.2), 2.5em 0em 0 0em rgba(31,174,92, 0.2), 1.75em 1.75em 0 0em rgba(31,174,92, 0.5), 0em 2.5em 0 0em rgba(31,174,92, 0.7), -1.8em 1.8em 0 0em #1fae5c, -2.6em 0em 0 0em rgba(31,174,92, 0.2), -1.8em -1.8em 0 0em rgba(31,174,92, 0.2);
  }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(31,174,92, 0.2), 1.8em -1.8em 0 0em rgba(31,174,92, 0.2), 2.5em 0em 0 0em rgba(31,174,92, 0.2), 1.75em 1.75em 0 0em rgba(31,174,92, 0.2), 0em 2.5em 0 0em rgba(31,174,92, 0.5), -1.8em 1.8em 0 0em rgba(31,174,92, 0.7), -2.6em 0em 0 0em #1fae5c, -1.8em -1.8em 0 0em rgba(31,174,92, 0.2);
  }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(31,174,92, 0.2), 1.8em -1.8em 0 0em rgba(31,174,92, 0.2), 2.5em 0em 0 0em rgba(31,174,92, 0.2), 1.75em 1.75em 0 0em rgba(31,174,92, 0.2), 0em 2.5em 0 0em rgba(31,174,92, 0.2), -1.8em 1.8em 0 0em rgba(31,174,92, 0.5), -2.6em 0em 0 0em rgba(31,174,92, 0.7), -1.8em -1.8em 0 0em #1fae5c;
  }`

const Loader = styled(Box)`
    margin: 100px auto;
    font-size: 25px;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    position: relative;
    text-indent: -9999em;
    animation: ${animate} 1.1s infinite ease;
    transform: translateZ(0) scale(0.7);
    `

export default function DotCircleLoader({ sx, ...other }: IDotCircleLoaderProps) {

    return (
        <Box width={'100%'} height={'100%'} sx={{display:'grid',placeContent:'center',...sx}} {...other}>
            <Loader />
        </Box>
    );
}
